export default "__VITE_ASSET__B47AY00U__"